import auth0 from '../auth0'
import { newRelicTriggerErrorEvent } from '../newrelic'

export default async function getClientTokenPasswordless(data: string): Promise<void> {
  try {
    const Authorization = await auth0().getTokenSilently({ ignoreCache: true })
    const url = `/customer-identity/single-sign-on/session/passwordless?data=${encodeURIComponent(
      data,
    )}`
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    if (!res.ok) {
      const json = await res.json()
      throw json
    }
  } catch (error) {
    newRelicTriggerErrorEvent('browse-passwordless', error)
  }
}
